export function cleanAndLowercase(inputString: string) {
    const cleanedString = inputString.replace(/[^a-zA-Z0-9]/g, '');
    const lowercaseString = cleanedString.toLowerCase();
    return lowercaseString;
}